import { post, get } from "../util/crmAxios";
import { getBasicUrls } from '../util/config';

// 吉尼斯学员列表
export const queryGuinnessStudent = params => post(getBasicUrls().schoolm + '/manage/schoolStudent/queryGuinnessStudent', params)
// 更新学员的英文名
export const updateGuinnessEnglishName = params => post(getBasicUrls().schoolm + '/manage/schoolStudent/updateGuinnessEnglishName', params)
// 获取吉尼斯感谢信模版
export const queryGuinnessTemplateUrl = params => post(getBasicUrls().schoolm + '/manage/schoolStudent/queryGuinnessTemplateUrl', params)
// 判断所选择的学员的状态
export const checkSelectGuinnessStudent = params => post(getBasicUrls().schoolm + '/manage/schoolStudent/checkSelectGuinnessStudent', params)
// 更新吉尼斯证书申请地址
export const updateGuinnessOrderAddress = params => post(getBasicUrls().schoolm + '/manage/schoolStudent/updateGuinnessOrderAddress', params)
//单个下载吉尼斯证书电子版
export const downLoadSingleCertificate = params => post(getBasicUrls().schoolm + '/manage/schoolStudent/downLoadSingleCertificate', params)
// 批量下载吉尼斯证书电子版
export const downLoadBatchCertificate = params => post(getBasicUrls().schoolm + '/manage/schoolStudent/downLoadBatchCertificate', params)
// 获取吉尼斯提交截止时间
export const queryGuinnessDeadline = params => post(getBasicUrls().schoolm + '/manage/schoolStudent/queryGuinnessDeadline', params)


//学费返还 list
export const tuitionListURL = params => post(getBasicUrls().schoolm + '/manage/tuitionRefund/queryReturnListByPage', params)
//课消返还 list
export const courseListURL = params => post(getBasicUrls().schoolm + '/manage/hoursConsumeRefund/queryReturnListByPage', params)
//计算月份
export const vectorsMonthURL = params => post(getBasicUrls().schoolm + `/manage/hoursConsumeRefund/calc?month=${params.month}`, params)
//确认月份
export const courseLMothURL = params => post(getBasicUrls().schoolm + `/manage/hoursConsumeRefund/confirm?month=${params.month}`, params);
//打地基数据异常提醒
export const queryDDJNotify = params => get(getBasicUrls().schoolm + '/manage/message//queryDDJNotify', params)
//提交采购单
export const submit = params => post(getBasicUrls().schoolm + `manage/purchase/order/submit?orderNo=${params}`, params)
//取消采购单
export const cancel = params => post(getBasicUrls().schoolm + `manage/purchase/order/cancel?orderNo=${params}`, params)
//查询商品权益
export const queryProductRight = params => post(getBasicUrls().schoolm +'manage/starright/queryProductRight', params)
//查询订单使用权益
export const queryOrderRight = params => post(getBasicUrls().schoolm +'manage/starright/queryOrderRight', params)
//新增修改采购订单
export const opPurchaseOrder = params => post(getBasicUrls().schoolm + 'manage/purchase/order/opPurchaseOrder', params)
//采购单-发货单-列表
export const queryAgentPurchase = params => post(getBasicUrls().schoolm + "manage/purchase/order/queryAgentPurchase", params)
//产品详情
export const getPurchaseOrderDetailProducts = params => get(getBasicUrls().schoolm + "manage/purchase/order/getPurchaseOrderDetailProducts", params)
//支付流水
export const getPurchaseOrderDetailSerials = params => get(getBasicUrls().schoolm + "manage/purchase/order/getPurchaseOrderDetailSerials", params)
//物流详情
export const queryPurchaseTrackInfo = params => get(getBasicUrls().schoolm + 'manage/agent/queryPurchaseTrackInfo', params)
//商品详情
export const getPurchaseOrderDetail = params => get(getBasicUrls().schoolm + "manage/purchase/order/getPurchaseOrderDetail", params)

//审核详情
export const getOrderAuditList = params => get(getBasicUrls().schoolm + "manage/credit/order/getOrderAuditList", params)

export const getSchoolProductPrices = params => get(getBasicUrls().schoolm + "manage/product/getSchoolProductPrices", params)
//获取代理商信息
export const querySchoolAgentByCampusId = params => get(getBasicUrls().schoolm + "manage/purchase/order/querySchoolAgentByCampusId", params)

//发货单导出
export const exportPurchaseOrder = params => post(getBasicUrls().schoolm + "manage/purchase/order/exportPurchaseOrder", params)
//获取模板文件下载地址
export const getTemplateDownloadUrl = params => post(getBasicUrls().schoolm + "manage/schoolimport/getTemplateDownloadUrl", params)
//校验导入
export const persistData = params => post(getBasicUrls().schoolm + "manage/schoolimport/persistData", params)
//校验进度
export const getBatchNum = params => get(getBasicUrls().schoolm + 'manage/schoolimport/getBatchNum', params)
//导入详情
export const importDetail = params => post(getBasicUrls().schoolm + "manage/schoolimport/queryImportRecord", params)
//获取学习机管理
export const studyMachineList = params => post(getBasicUrls().schoolm + 'manage/agent/querySchoolLearnMachine', params)
//学习机修改
export const changeLearningMachine = params => post(getBasicUrls().schoolm + 'manage/agent/changeLearningMachine', params)
//检查人脸换绑学习机
export const checkFaceChangeLearningMachine = params => post(getBasicUrls().schoolm + 'manage/agent/checkFaceChangeLearningMachine', params)
//批量学习机修改
export const batchChangeLearningMachine = params => post(getBasicUrls().schoolm + 'manage/agent/batchChangeLearningMachine', params)
// 查询校区名称
export const queryCampusName = params => get(getBasicUrls().schoolm + `manage/schoolinfo/queryCampusName?campusId=${params}`)
// 发送验证码
export const validateCode = params => get(getBasicUrls().schoolm + `manage/agent/validateCode?mobile=${params}`)
//校验验证
export const checkValidateCode = params => get(getBasicUrls().schoolm + `manage/agent/checkValidateCode?mobile=${params.mobile}&vCode=${params.vCode}`)
//生成短链
export const generateShortUrl = params => post(getBasicUrls().schoolm + 'manage/agent/generateShortUrl', params)
//查询物流信息
export const queryTrackInfo = params => post(getBasicUrls().schoolm + 'manage/agent/queryTrackInfo', params)
//更改分销员
export const agentAllot = params => post(getBasicUrls().schoolm + 'manage/agent/agentAllot', params)
export const queryAllTrackCompany = params => get(getBasicUrls().schoolm + 'manage/agent/queryAllTrackCompany', params)

export const editOrderDisCount = params => post(getBasicUrls().schoolm + 'manage/purchase/order/editOrderDisCount', params)
export const queryActivePurchaseOrder = params => get(getBasicUrls().schoolm + 'manage/agent/queryActivePurchaseOrder', params)
export const queryActiveModelPurchaseOrder = params => post(getBasicUrls().schoolm + 'manage/agent/queryActiveModelPurchaseOrder', params)
export const queryBatchActiveModelOrder = params => post(getBasicUrls().schoolm + 'manage/agent/queryBatchActiveModelOrder', params)
//转校列表
export const queryTransferSchool = params => post(getBasicUrls().schoolm + 'manage/schoolStudent/queryTask', params)
//转校审批
export const auditTask = params => post(getBasicUrls().schoolm + 'manage/schoolStudent/auditTask', params)

//学习机学院列表
export const queryLearningMachineStudent = params => post(getBasicUrls().schoolm + 'manage/schoolStudent/queryLearningMachineStudent', params)
// 账号解绑
export const forceUnbind = params => post(getBasicUrls().schoolm + 'manage/machine/forceUnbind', params)

// 撤回申请
export const userApplyAudit = params => post(getBasicUrls().schoolm + 'manage/agent/userApplyAudit', params)

// 提交资料、绑定申请
export const accountUserApply = params => post(getBasicUrls().schoolm + 'manage/agent/accountUserApply', params)

// ---------新增服务中心----------
//申请转入服务中心
export const studentTransferApply = (params) => post(getBasicUrls().schoolm + 'servicepoint/studentTransferApply', params)
//查询账号信息
export const queryAccountInfo =(params) => post(getBasicUrls().schoolm  + 'servicepoint/queryAccountInfo',params)
//查询学员转入申请列表
export const queryNeedConfirmedStudent =(params) => post(getBasicUrls().schoolm  + 'servicepoint/queryNeedConfirmedStudent',params)
//学员转入审核
export const studentTransferConfirmed =(params) => post(getBasicUrls().schoolm  + 'servicepoint/studentTransferConfirmed',params)
// 修改账户认证省份城市信息
export const servicePointModifyCity = params => post(getBasicUrls().schoolm + 'manage/machine/servicePointModifyCity', params)
// 修改认证城市信息
export const servicePointSubscriptionSubject = params => post(getBasicUrls().schoolm + 'manage/machine/servicePointSubscriptionSubject', params)
// 订阅管理时长
export const querySPLearningAccountHourDetails = params => post(getBasicUrls().schoolm + 'manage/machine/querySPLearningAccountHourDetails', params)
// 订阅学科
export const servicePointUnSubscribe = params => post(getBasicUrls().schoolm + 'manage/machine/servicePointUnSubscribe', params)
// 取消订阅
export const servicePointConsumeCard = params => post(getBasicUrls().schoolm + 'manage/card/servicePointConsumeCard', params)
//订阅授权申请
export const subAuthApply = params => post(getBasicUrls().schoolm + 'servicepoint/subAuthApply', params)
// 手机号换棒
export const servicePointChangeLearningMachine = params => post(getBasicUrls().schoolm + 'manage/agent/servicePointChangeLearningMachine', params)
// 绑定账号
export const servicePointBindUserAccount = params => post(getBasicUrls().schoolm + 'manage/agent/servicePointBindUserAccount', params)
// 账号转移
export const studentMove = params => post(getBasicUrls().schoolm + 'manage/schoolStudent/studentMove', params)
// ---------end----------


//账户管理
export const getLearningAccountPage = (params) => post(getBasicUrls().schoolm + 'manage/machine/getLearningAccountPage', params)

//根据账号查询学员信息
export const getUserInfoByUname = (params) => post(getBasicUrls().schoolm + 'manage/schoolStudent/getUserInfoByUname', params)
//账户绑定学员学习帐号
export const bindUserAccount = (params) => post(getBasicUrls().schoolm + 'manage/agent/bindUserAccount', params)
//获取设备账户信息
export const getAccountBaseInfo = (params) => get(getBasicUrls().schoolm + 'manage/machine/getAccountBaseInfo', params)
//根据城市id和设备型号获取学习时长
export const getCityHourConfig = (params) => get(getBasicUrls().schoolm + 'manage/machine/getCityHourConfig', params)
//修改账户认证省份城市信息
export const modifyCity = (params) => post(getBasicUrls().schoolm + 'manage/machine/modifyCity', params)
//最大可赠送活动时长查询
export const queryMaxGiftHours = (params) => post(getBasicUrls().schoolm + 'manage/buy/queryMaxGiftHours', params)
//赠送活动时长
export const giftActivityHours = (params) => post(getBasicUrls().schoolm + 'manage/buy/giftActivityHours', params)
//赠送时长活动是否有效
export const queryActivityIsValid = (params) => post(getBasicUrls().schoolm + 'manage/buy/queryActivityIsValid', params)

//更新账户状态
export const updateAccountStatus = (params) => post(getBasicUrls().schoolm + 'manage/machine/updateAccountStatus', params)
//更新账户状态
export const getConversionHours = (params) => post(getBasicUrls().schoolm + 'manage/machine/getConversionHours', params)
//判断订单是否可以支付
export const checkPurchaseOrderPay = (params) => post(getBasicUrls().schoolm + 'manage/purchase/order/checkPurchaseOrderPay', params)
//账户消费明细（分页）
export const getLearningAccountHourPages = (params) => post(getBasicUrls().schoolm + 'manage/machine/getLearningAccountHourPages', params)
//学习机备注添加
export const addLearnMachineRecord = (params) => post(getBasicUrls().schoolm + 'manage/agent/addLearnMachineRecord', params)
//订阅学科
export const subscribeSub = params => post(getBasicUrls().schoolm + 'manage/machine/subscriptionSubject', params)
//退订学科
export const unsubscribeSub = params => post(getBasicUrls().schoolm + 'manage/machine/unSubscribe', params)
//取消退订学科
export const cancelsubscribeSub = params => post(getBasicUrls().schoolm + 'manage/machine/cancelUnSubscribe', params)
//学习机跨区域激活记录列表-查询
export const getMachineCrossRegRecordList = params => post(getBasicUrls().schoolm + 'machine/crossrecord/getMachineCrossRegRecordList', params)
//经销商系统-学习机跨区域活跃记录列表-分页查询
export const getMachineCrosslivelyList = params => post(getBasicUrls().schoolm + 'machine/crossrecord/get-machine-crosslively-list', params)
//经销商系统-新增跨区域活跃报备
export const addMachineCrossReport = params => post(getBasicUrls().schoolm + 'machine/crossrecord/add-machine-cross-report', params)
//取消退订学科
export const queryStudentExperienceAccount = params => post(getBasicUrls().schoolm + 'manage/schoolStudent/queryStudentExperienceAccount', params)
//获取厂商信息
export const getLearningMachineFirms = params => get(getBasicUrls().schoolm + 'manage/firm/getLearningMachineFirms', params)
//给采购单分配厂商
export const allocateOrderFirm = params => post(getBasicUrls().schoolm + 'manage/firm/allocateOrderFirm', params)
//查询维修单弹窗数据
export const getPopupData = params => post(getBasicUrls().schoolm + 'manage/apply/getPopupData', params)
//退换货列表
export const getLearningMachineApplyPage = params => post(getBasicUrls().schoolm + 'manage/apply/getLearningMachineApplyPage', params)
//获取退换货-返修详情
export const getLearningMachineApplyInfo = params => get(getBasicUrls().schoolm + 'manage/apply/getLearningMachineApplyInfo', params)
//退换货-返修-添加修改
export const saveLearningMachineApply = params => post(getBasicUrls().schoolm + 'manage/apply/saveLearningMachineApply', params)
//退换货-返修-返修单审核
export const auditLearningMachineApply = params => post(getBasicUrls().schoolm + 'manage/apply/auditLearningMachineApply', params)
//退换货-返修-商品类型
export const getRepairProductModel = params => get(getBasicUrls().schoolm + 'manage/product/getRepairProductModel', params)
//退换货-返修-返厂快递
export const factoryLearningMachineApply = params => post(getBasicUrls().schoolm + 'manage/apply/factoryLearningMachineApply', params)
//退换货-返修-获取售后维修方式
export const getRecursionDictionaryList = params => get(getBasicUrls().schoolm + 'manage/apply/getRecursionDictionaryList', params)
//退换货-返修-获取评价配置
export const getEvaluateLabel = params => get(getBasicUrls().schoolm + 'manage/apply/getEvaluateLabel', params)
//退换货-返修-评价接口
export const evaluate = params => post(getBasicUrls().schoolm + 'manage/apply/evaluate', params)
//退换货-返修-维修结果处理
export const handleLearningMachineApply = params => post(getBasicUrls().schoolm + 'manage/apply/handleLearningMachineApply', params)
//删除采购单
export const deletePurchaseOrder = params => get(getBasicUrls().schoolm + 'manage/purchase/order/deletePurchaseOrder', params)
//退货
export const orderReturn = params => post(getBasicUrls().schoolm + 'manage/agent/orderReturn', params)
//添加修改开票信息
export const saveAgentInvoice = params => post(getBasicUrls().schoolm + 'manage/agent/invoice/saveAgentInvoice', params)
//添加修改开票信息
export const getAgentInvoiceInfo = params => get(getBasicUrls().schoolm + 'manage/agent/invoice/getAgentInvoiceInfo', params)
//添加修改开票信息
export const queryAgentInvoiceList = params => post(getBasicUrls().schoolm + 'manage/agent/invoice/queryAgentInvoiceList', params)
//添加修改开票信息
export const auditAgentInvoice = params => post(getBasicUrls().schoolm + 'manage/agent/invoice/auditAgentInvoice', params)
//获取要发货的采购单信息
export const getAllocateOrder = params => get(getBasicUrls().schoolm + 'manage/firm/getAllocateOrder', params)
//获取要发货的采购单信息
export const queryFirmLearningMachine = params => post(getBasicUrls().schoolm + 'manage/agent/queryFirmLearningMachine', params)
//获取要发货的采购单信息
export const firmSendGoods = params => post(getBasicUrls().schoolm + 'manage/firm/firmSendGoods', params)
//获取要发货的采购单信息
export const checkSnCodeExist = params => post(getBasicUrls().schoolm + 'manage/firm/checkSnCodeExist', params)
// 备用机管理-查询备用机额度
export const queryBackupPhoneQuota = params => post(getBasicUrls().schoolm + 'backupPhone/manage/queryQuota', params)
// 备用机管理-根据SN校验设备
export const queryBackupPhoneDeviceManage = params => post(getBasicUrls().schoolm + 'backupPhone/manage/queryDeviceBySn', params)
// 备用机管理-分页查询备用机列表
export const pageBackupPhoneManage = params => post(getBasicUrls().schoolm + 'backupPhone/manage/pageBackupPhone', params)
// 备用机管理-标记备用机
export const markBackupPhoneManage = params => post(getBasicUrls().schoolm + 'backupPhone/manage/markBackupPhone', params)
// 备用机管理-导出备用机列表
export const exportBackupPhoneManage = params => post(getBasicUrls().schoolm + 'backupPhone/manage/exportBackupPhone', params)

//学习机snCode更新  --- 工具集
export const snCodeChange = params => post(getBasicUrls().schoolm + 'small/tool/snCodeChange', params)
export const addModifyServicePoint = params => post(getBasicUrls().schoolm + 'small/tool/addModifyServicePoint', params)
export const orderMarkingTool = params => post(getBasicUrls().schoolm + 'small/tool/orderMarkingTool', params)
export const rechargeAgent = params => post(getBasicUrls().schoolm + 'small/tool/rechargeAgent', params)
//添加修改开票信息
export const queryAgentCounterPage = params => post(getBasicUrls().schoolm + 'manage/counter/queryAgentCounterPage', params)
//添加修改柜台信息
export const saveCounter = params => post(getBasicUrls().schoolm + 'manage/counter/saveCounter', params)
//获取柜台信息
export const getCounterById = params => get(getBasicUrls().schoolm + 'manage/counter/getCounterById', params)
//柜台信息审核
export const auditCounter = params => post(getBasicUrls().schoolm + 'manage/counter/auditCounter', params)
//赠送课时
export const giftHours = params => post(getBasicUrls().schoolm + 'manage/buy/giftHours', params)
//学员解绑学习机
export const unBindUserAccount = params => post(getBasicUrls().schoolm + 'manage/machine/unBindUserAccount', params)
//B端取消订阅
export const unSubscribe = params => post(getBasicUrls().schoolm + 'manage/machine/unSubscribe', params)
//订阅卡查询
export const queryLearningCard = params => post(getBasicUrls().schoolm + 'manage/card/queryLearningCard', params)
//查询相关订阅卡
export const queryRelationCards = params => post(getBasicUrls().schoolm + 'manage/card/queryRelationCards', params)
//订阅卡退卡结算
export const createLearningCardSettlementOrder = params => post(getBasicUrls().schoolm + 'manage/card/createLearningCardSettlementOrder', params)
//学习卡获取密码
export const queryCardPassword = params => post(getBasicUrls().schoolm + 'manage/card/queryCardPassword', params)
//学习卡延期
export const extensionValidity = params => post(getBasicUrls().schoolm + 'manage/card/extensionValidity', params)
//学习卡 作废
export const disableCard = params => post(getBasicUrls().schoolm + 'manage/card/disableCard', params)
// 学习卡启用
export const enableCard = params => post(getBasicUrls().schoolm + 'manage/card/enableCard', params)
// 订阅卡核销
export const consumeCard = params => post(getBasicUrls().schoolm + 'manage/card/consumeCard', params)
// 订阅卡核销查询
export const queryConsume = params => post(getBasicUrls().schoolm + 'manage/card/queryConsume', params)
// 服务中心视频通话记录
export const queryAgentCallRecords = params => post(getBasicUrls().schoolm + 'servicepoint/queryAgentCallRecords', params)
// 代理商看板
export const queryLearningMachineRegionPage = params => post(getBasicUrls().schoolm + 'manage/purchase/order/queryLearningMachineRegionPage', params)

// 订阅卡返还记录
export const campus_sub_stat_detail = params => post(getBasicUrls().schoolm + 'manage/cardreturn/campus_sub_stat_detail', params)


// 返还对帐单列表
export const queryRegionReturnOrderList = params => post(getBasicUrls().schoolm + 'manage/transfer/order/queryRegionReturnOrderList', params)
// 确定提现反还单列表
export const getRegionReturnOrderList = params => post(getBasicUrls().schoolm + 'manage/transfer/order/getRegionReturnOrderList', params)
// 确定提现
export const confirmReturnOrder = params => post(getBasicUrls().schoolm + 'manage/transfer/order/confirmReturnOrder', params)
// 可提现金额合计
export const queryRegionReturnOrderTotalAmount = params => post(getBasicUrls().schoolm + 'manage/transfer/order/queryRegionReturnOrderTotalAmount', params)
// 市级代理申请列表
export const queryAgentRegionFeePage = params => post(getBasicUrls().schoolm + 'manage/purchase/order/queryAgentRegionFeePage', params)

// 获取所有商品信息概况
export const getGoodsDisplay = params => get(getBasicUrls().schoolm + 'manage/product/getGoodsDisplay', params)
// 柜台状态开启关闭
export const saveCounterStatus = params => post(getBasicUrls().schoolm + 'manage/counter/saveCounterStatus', params)
// 初诊
export const firstDiagnosisLearningMachineApply = params => post(getBasicUrls().schoolm + 'manage/apply/firstDiagnosisLearningMachineApply', params)
// 质检
export const qualityTesting = params => post(getBasicUrls().schoolm + 'manage/apply/qualityTesting', params)
// 检测
export const check = params => post(getBasicUrls().schoolm + 'manage/apply/check', params)
// 查询维修收费价格单
export const getMaintainPriceList = params => get(getBasicUrls().schoolm + 'manage/apply/getMaintainPriceList', params)
// 填写报价单
export const quotationOrder = params => post(getBasicUrls().schoolm + 'manage/apply/quotationOrder', params)
// 查询维修报价单pdf数据
export const queryMaintainOrderPDFData = params => post(getBasicUrls().schoolm + 'manage/apply/queryMaintainOrderPDFData', params)
// 查询维修快递数据
export const queryExpressInfo = params => post(getBasicUrls().schoolm + 'manage/apply/queryExpressInfo', params)
// 维修支付
export const maintainPay = params => post(getBasicUrls().schoolm + 'manage/apply/maintainPay', params)
// 维修支付
export const generatePaymentQRCode = params => post(getBasicUrls().schoolm + 'manage/apply/generatePaymentQRCode', params)
// 维修支付验证
export const queryQuotation = params => post(getBasicUrls().schoolm + 'manage/apply/queryQuotation', params)
// 保内维修
export const inWarrantyPeriodMaintain = params => post(getBasicUrls().schoolm + 'manage/apply/inWarrantyPeriodMaintain', params)
// 保内维修
export const outWarrantyPeriodMaintain = params => post(getBasicUrls().schoolm + 'manage/apply/outWarrantyPeriodMaintain', params)
// 获取售后维修故障分类字典
export const queryDictionarySalesListByParent = params => get(getBasicUrls().schoolm + 'manage/apply/queryDictionarySalesListByParent', params)


// 查询订阅相关日志
export const queryAccontSubLog = params => post(getBasicUrls().schoolm + 'manage/machine/queryAccontSubLog', params)
// 借调货订单分页查询
export const queryAgentTransferOrder = params => post(getBasicUrls().schoolm + 'manage/transfer/order/queryAgentTransferOrder', params)

// 获取代理商信息和区域代理商信息
export const queryTransferAgentByCampusId = params => get(getBasicUrls().schoolm + 'manage/transfer/order/queryTransferAgentByCampusId', params)
// 获取代理商信息和区域代理商信息 商品列表信息
export const getTransferOrderDetailProducts = params => get(getBasicUrls().schoolm + 'manage/transfer/order/getTransferOrderDetailProducts', params)
// 获取借调货单订单信息
export const getTransferOrderDetail = params => get(getBasicUrls().schoolm + 'manage/transfer/order/getTransferOrderDetail', params)
// 获取借调货单订单信息
export const opTransferOrder = params => post(getBasicUrls().schoolm + 'manage/transfer/order/opTransferOrder', params)
// 借调货订单发货管理查询
export const queryAgentTransferDispatchOrder = params => post(getBasicUrls().schoolm + 'manage/transfer/order/queryAgentTransferDispatchOrder', params)
// 借调货订单发货明细查询
export const queryAgentTransferDispatchDetail = params => post(getBasicUrls().schoolm + 'manage/transfer/order/queryAgentTransferDispatchDetail', params)
// 区代发货取消操作
export const dispatchOrderCancel = params => post(getBasicUrls().schoolm + 'manage/transfer/order/dispatchOrderCancel', params)
// 总部调货记录
export const queryMachineChangeLog = params => post(getBasicUrls().schoolm + 'manage/agent/queryMachineChangeLog', params)
// 借调货代理商取消操作
export const transferOrderCancel = params => post(getBasicUrls().schoolm + 'manage/transfer/order/transferOrderCancel', params)
// 借调货区代确认操作
export const transferRegionOrderConfirm = params => post(getBasicUrls().schoolm + 'manage/transfer/order/transferRegionOrderConfirm', params)
// 省代确认操作
export const transferRegionOrderAudit = params => post(getBasicUrls().schoolm + 'manage/transfer/order/transferRegionOrderAudit', params)
// 借调货代理商收货确认操作
export const transferOrderConfirm = params => post(getBasicUrls().schoolm + 'manage/transfer/order/transferOrderConfirm', params)
// 调货页面展示数据
export const getTransferOrder = params => post(getBasicUrls().schoolm + 'manage/transfer/order/getTransferOrder', params)
// 调货页面获取区域代理商的学习机列表
export const getTransferLearningMachineList = params => post(getBasicUrls().schoolm + 'manage/transfer/order/getTransferLearningMachineList', params)
// 调货页面获取区域代理商-学习机调货
export const saveTransferLearningMachine = params => post(getBasicUrls().schoolm + 'manage/transfer/order/saveTransferLearningMachine', params)
// 更改学习机账号
export const changeMachineAccount = params => post(getBasicUrls().schoolm + 'manage/machine/changeMachineAccount', params)
// 返还单申请
export const cardReturnApply = params => post(getBasicUrls().schoolm + 'manage/cardreturn/cardReturnApply', params)
// 返还单查询
export const queryCardReturn = params => post(getBasicUrls().schoolm + 'manage/cardreturn/queryCardReturn', params)
// 返还单审核
export const cardReturnAudit = params => post(getBasicUrls().schoolm + 'manage/cardreturn/cardReturnAudit', params)
// 返还单详情1
export const queryCardReturnMain = params => get(getBasicUrls().schoolm + 'manage/cardreturn/queryCardReturnMain', params)
// 返还单详情2
export const queryCardReturnDetail = params => get(getBasicUrls().schoolm + 'manage/cardreturn/queryCardReturnDetail', params)
// 查询校区账户信息
export const queryBankInfo = params => get(getBasicUrls().schoolm + 'manage/schoolInfoExtend/queryBankInfo', params)
// 获取账户信息
export const getAccountBaseInfoBySn = params => get(getBasicUrls().schoolm + 'manage/machine/getAccountBaseInfoBySn', params)
// 返还单返还
export const cardReturnPay = params => post(getBasicUrls().schoolm + 'manage/cardreturn/cardReturnPay', params)
// 采购单代理商收货确认操作
export const purchaseOrderConfirm = params => post(getBasicUrls().schoolm + 'manage/purchase/order/purchaseOrderConfirm', params)
// 强制收货确认信息查询
export const queryConfirmMsg = params => get(getBasicUrls().schoolm + 'manage/msg/queryConfirmMsg', params)
// 采购单代理商收货确认
export const msgConfirm = params => post(getBasicUrls().schoolm + 'manage/msg/msgConfirm', params)
// 采购单代理商开票确认操作
export const purchaseOrderInvoiceConfirm = params => post(getBasicUrls().schoolm + 'manage/purchase/order/purchaseOrderInvoiceConfirm', params)
// 发提货券
export const sendDeliveryVoucher = params => post(getBasicUrls().schoolm + "manage/dual/order/sendDeliveryVoucher", params);
// 设备明细报表
export const queryMachineValuePage = params => post(getBasicUrls().schoolm + 'manage/agent/queryMachineValuePage', params)
// 采购明细报表
export const queryOrderValuePage = params => post(getBasicUrls().schoolm + 'manage/purchase/order/queryOrderValuePage', params)
// 发货明细报表
export const queryDispatchValuePage = params => post(getBasicUrls().schoolm + 'manage/purchase/order/queryDispatchValuePage', params)
// 查询借调货最大代金券金额
export const queryTransferMaxVoucherPrice = params => get(getBasicUrls().schoolm + 'manage/transfer/order/queryTransferMaxVoucherPrice', params)
// 借调货单付款
export const transferOrderPay = params => post(getBasicUrls().schoolm + 'manage/transfer/order/transferOrderPay', params)
// 查询区域代理的区域内代理商信息
export const queryRegionSubCampusList = params => get(getBasicUrls().schoolm + 'manage/transfer/order/queryRegionSubCampusList', params)
// 查询区域代理的区域内代理商信息
export const queryRegionSubCampusListV3 = params => get(getBasicUrls().schoolm + 'manage/transfer/order/queryRegionSubCampusListV3', params)
// 查询区域代理的区域内代理商信息V2版本，需要保留
export const queryRegionSubCampusListV2 = params => get(getBasicUrls().schoolm + 'manage/transfer/order/queryRegionSubCampusListV2', params)
// 学员转校申请
export const transferSchoolApply = params => post(getBasicUrls().schoolm + 'manage/schoolLearningStudentTransfer/transferSchoolApply', params)
// 转入记录
export const queryStudentTransfer = params => post(getBasicUrls().schoolm + 'manage/schoolLearningStudentTransfer/queryStudentTransfer', params)
// 取消转校
export const cancelTask = params => post(getBasicUrls().schoolm + 'manage/schoolLearningStudentTransfer/cancelTask', params)
// 审核
export const auditTask1 = params => post(getBasicUrls().schoolm + 'manage/schoolLearningStudentTransfer/auditTask', params)
// 获取代理商的柜台信息-列表
export const getCounterListById = params => get(getBasicUrls().schoolm + 'manage/counter/getCounterListById', params)
// 设备分配柜台
export const machineDistributionCounter = params => post(getBasicUrls().schoolm + 'manage/counter/machineDistributionCounter', params)
// 审核
export const addEditTeacherInfoV2 = params => post(getBasicUrls().schoolm + 'manage/schoolLearningStudentTransfer/addEditTeacherInfoV2', params)
// 发票查询
export const queryOrderInvoiceForPage = params => post(getBasicUrls().schoolm + 'manage/purchaseInvoice/queryOrderInvoiceForPage', params)
// 发票作废
export const invalidInvoice = params => get(getBasicUrls().schoolm + 'manage/purchaseInvoice/invalidInvoice', params)
// 发票作废
export const cancelAuditAgentInvoice = params => post(getBasicUrls().schoolm + 'manage/agent/invoice/cancelAuditAgentInvoice', params)
// 维修回寄快递
export const expressToUser = params => post(getBasicUrls().schoolm + 'manage/apply/expressToUser', params)
// 根据 SN 码查询设备信息
export const queryMachineInfoSimInfo = params => get(getBasicUrls().schoolm + 'manage/machine/queryMachineInfoSimInfo', params)

// -------------------维修管理-换新流程----------------------------------
// 复检返修单
export const recheckApply = params => post(getBasicUrls().schoolm + 'manage/apply/recheckApply', params)
export const renewExpressToUser = params => post(getBasicUrls().schoolm + 'manage/apply/renewExpressToUser', params)
// 争议结果
export const disputeApply = params => post(getBasicUrls().schoolm + 'manage/apply/disputeApply', params)
// 更新维修单SN码
export const updateApplyMachineSnCode = (params) => post(getBasicUrls().schoolm + 'manage/apply/updateApplyMachineSnCode', params);
//----------------------------------------------------------------
// 验证取消订阅是否赠送课时
export const checkCanGiftHour = params => post(getBasicUrls().schoolm + 'manage/machine/checkCanGiftHour', params)
// 获取充值方式
export const queryPayDetailList = params => post(getBasicUrls().schoolm + 'manage/config/queryPayDetailList', params)
// 获取城市
export const queryAgentArea = params => get(getBasicUrls().schoolm + 'manage/machine/queryAgentArea', params)
// 设备-样机详情
export const queryMachineSampleInfo = params => get(getBasicUrls().schoolm + 'manage/machine/queryMachineSampleInfo', params)
// 标记样机
export const machineSignSample = params => post(getBasicUrls().schoolm + 'manage/machine/machineSignSample', params)
// 样机列表
export const queryMachineSampleForPage = params => post(getBasicUrls().schoolm + 'manage/machine/queryMachineSampleForPage', params)
//
export const continueSubscribe = params => get(getBasicUrls().schoolm + 'manage/machine/continueSubscribe', params)
// 取消样机
export const cancelMachineSample = params => get(getBasicUrls().schoolm + 'manage/machine/cancelMachineSample?', params)
// ----------------------------------------------------------------------
export const querySchoolLearnMachine = params => post(getBasicUrls().schoolm + 'manage/agent/querySchoolLearnMachine', params)

// 子女样机列表
export const querychildMachineApplyPage = params => post(getBasicUrls().schoolm + 'manage/childmachine/querychildMachineApplyPage', params)
// 子女机查看申请信息
export const getMachineApplyInfo = params => get(getBasicUrls().schoolm + 'manage/childmachine/getMachineApplyInfo', params)
// 子女样机审核
export const childMachineAudit = params => post(getBasicUrls().schoolm + 'manage/childmachine/childMachineAudit', params)
// 子女样机审核
export const queryPayDetailList2 = params => post(getBasicUrls().schoolm + 'manage/config/queryPayDetailList', params)
// 子女机账号申请修改
export const childMachineApply = params => post(getBasicUrls().schoolm + 'manage/childmachine/childMachineApply', params)
// 当前代理以及上级区代信息
export const getCampusParentInfo = params => get(getBasicUrls().schoolm + 'manage/childmachine/getCampusParentInfo', params)
// 出库单列表
export const queryCkOrder = params => post(getBasicUrls().schoolm + 'manage/goodsdeliver/queryCkOrder', params)
// 出库单导出
export const exportCkOrder = params => post(getBasicUrls().schoolm + 'manage/goodsdeliver/exportCkOrder', params)
// 出库单详情
export const queryCkOrderByCkNo = params => get(getBasicUrls().schoolm + 'manage/goodsdeliver/queryCkOrderByCkNo', params)
// 出库单详情
export const queryCkOrTkOrderByNo = params => get(getBasicUrls().schoolm + 'manage/goodsdeliver/queryCkOrTkOrderByNo', params)
// 获取订单发货状态下拉列表
export const getOrderDeliveryStatusList = (params) => get(getBasicUrls().schoolm + 'manage/goodsdeliver/getOrderDeliveryStatusList', params)
// 获取订单发货状态下拉列表
export const getOutWarehouseList = (params) => get(getBasicUrls().schoolm + 'manage/goodsdeliver/getOutWarehouseList', params)
// PN出库单详情
export const queryLading = params => post(getBasicUrls().schoolm + 'manage/warehouse/lading/queryLading', params)
// 出库单取消
export const ckOrderCancel = params => post(getBasicUrls().schoolm + 'manage/goodsdeliver/ckOrderCancel', params)
// 出库单取消
export const ckOrTkOrderCancel = params => post(getBasicUrls().schoolm + 'manage/goodsdeliver/ckOrTkOrderCancel', params)
// 出库PN单取消
export const cancelLading = params => post(getBasicUrls().schoolm + 'manage/warehouse/lading/cancelLading', params)
// 出库明细列表
export const queryStockOutDetailPage = params => post(getBasicUrls().schoolm + 'manage/productStock/queryStockOutDetailPage', params)
// 出库明细取消
export const cancelStockOut = params => post(getBasicUrls().schoolm + 'manage/productStock/cancelStockOut', params)
// 入库商品列表
export const getRelationModelList = params => get(getBasicUrls().schoolm + 'manage/stock/getRelationModelList', params)
// 入库预分配列表查询
export const queryProductStockAllocationPage = params => post(getBasicUrls().schoolm + 'manage/allocation/queryProductStockAllocationPage', params)
// 入库预分配列表详情查询
export const getStockAllocation = params => post(getBasicUrls().schoolm + 'manage/allocation/getStockAllocation', params)
// 预测分配查询
export const queryStockAllocation = params => post(getBasicUrls().schoolm + 'manage/allocation/queryStockAllocation', params)
// 分配数据保存
export const saveStockAllocation = params => post(getBasicUrls().schoolm + 'manage/allocation/saveStockAllocation', params)
// 入库仓库列表
export const getWarehouseList = params => get(getBasicUrls().schoolm + 'manage/stock/getWarehouseList', params)
// 入库单列表
export const queryProductStockPage = params => post(getBasicUrls().schoolm + 'manage/stock/queryProductStockPage', params)
// 入库单详情
export const getProductStock = params => get(getBasicUrls().schoolm + 'manage/stock/getProductStock', params)
// 入库信息保存
export const saveProductStock = params => post(getBasicUrls().schoolm + 'manage/stock/saveProductStock', params)
// 入库单删除
export const deleteProductStock = params => post(getBasicUrls().schoolm + 'manage/stock/deleteProductStock', params)
//入库sn导入
export const uploadSnData = params => post(getBasicUrls().schoolm + "manage/productStockImport/uploadData", params)
//校验导入
export const persistSnData = params => post(getBasicUrls().schoolm + "manage/productStockImport/persistData", params)
// 入库明细列表
export const queryStockInDetailPage = params => post(getBasicUrls().schoolm + 'manage/productStock/queryStockInDetailPage', params)
// 入库明细取消
export const cancelStockIn = params => post(getBasicUrls().schoolm + 'manage/productStock/cancelStockIn', params)
// 查询发货状态列表
export const querySoStatus = params => get(getBasicUrls().schoolm + 'manage/goodsdeliver/querySoStatus', params)
// 查询发货状态列表
export const queryJdWarehouse = params => get(getBasicUrls().schoolm + 'manage/goodsdeliver/queryJdWarehouse', params)
// 根据采购单生成出库单
export const createSingleCkOrder = params => post(getBasicUrls().schoolm + 'manage/goodsdeliver/createSingleCkOrder', params)
// 获取区代发货代理商
export const higherRegionAgent = params => post(getBasicUrls().schoolm + 'manage/purchase/order/higherRegionAgent', params)
// 调整总部采购订单的发货方式
export const adjustOrderRegionAgent = params => post(getBasicUrls().schoolm + 'manage/purchase/order/adjustOrderRegionAgent', params)
// 采购订单下单时-获取订单类型下拉信息
export const queryAgentOrderTypes = params => get(getBasicUrls().schoolm + 'manage/purchase/order/queryAgentOrderTypes', params)
// 区代发货-取消发货
export const cancelDispatchReturn = params => post(getBasicUrls().schoolm + 'manage/transfer/order/cancelDispatchReturn', params)
// 获取京东商品
export const queryJdProductList = params => get(getBasicUrls().schoolm + 'manage/agent/express/queryJdProductList', params)
// 京东仓发货参数配置分页
export const queryProductExpressPage = params => post(getBasicUrls().schoolm + 'manage/agent/express/queryProductExpressPage', params)
// 京东仓发货参数值获取下拉
export const queryExpressRuleValue = params => get(getBasicUrls().schoolm + 'manage/agent/express/queryExpressRuleValue', params)
// 京东仓发货参数添加修改
export const saveJdProductExpress = params => post(getBasicUrls().schoolm + 'manage/agent/express/saveJdProductExpress', params)
// 区域代理发货-京东仓发货
export const createRegionSingleCkOrder = params => post(getBasicUrls().schoolm + 'manage/goodsdeliver/createRegionSingleCkOrder', params)
// 获取代理商仓库列表
export const queryAgentWarehouseList = params => get(getBasicUrls().schoolm + 'manage/purchase/order/queryAgentWarehouseList', params)
// 根据采购单查询代理商仓库列表
export const queryWarehouseListByPurchaseNo = params => get(getBasicUrls().schoolm + 'small/tool/queryWarehouseListByPurchaseNo', params)
// 审核调拨单
export const reviewTransferOrder = params => post(getBasicUrls().schoolm + 'manage/warehouse/transfer/reviewTransferOrder', params)
// 查询调拨单详情
export const queryTransferOrder = params => post(getBasicUrls().schoolm + 'manage/warehouse/transfer/queryTransferOrder', params)
// 调货单查询
export const queryTkOrders = params => post(getBasicUrls().schoolm + 'manage/tk/queryTkOrders', params)
// 调货单导出
export const tkOrdersExport = params => post(getBasicUrls().schoolm + 'manage/tk/tkOrdersExport', params)
// 调货单取消
export const tkOrderCancel = params => post(getBasicUrls().schoolm + 'manage/tk/tkOrderCancel', params)
// 调货TO单取消
export const cancelTransferOrder = params => post(getBasicUrls().schoolm + 'manage/warehouse/transfer/cancelTransferOrder', params)
// 京东仓发货参数删除
export const delJdProductExpress = params => post(getBasicUrls().schoolm + 'manage/agent/express/delJdProductExpress', params)
// 赊货订单查询
export const queryAgentCreditOrder = params => post(getBasicUrls().schoolm + 'manage/credit/order/queryAgentCreditOrder', params)
// 赊货订单添加修改
export const opCreditOrder = params => post(getBasicUrls().schoolm + 'manage/credit/order/opCreditOrder', params)
// 支付前检查订单
export const checkCreditOrderPay = params => post(getBasicUrls().schoolm + 'manage/credit/order/checkCreditOrderPay', params)
// 选择关联代理商
export const queryRelatedAgentList = params => get(getBasicUrls().schoolm + 'manage/transfer/order/queryRelatedAgentList', params)
// 获取标记双重订单的代理商信息
export const queryDualOrderAgentPage = params => post(getBasicUrls().schoolm + 'manage/dual/order/queryDualOrderAgentPage', params)
//新增修改记双重订单
export const opDualOrder = params => post(getBasicUrls().schoolm + 'manage/dual/order/opDualOrder', params)
//判断双重订单是否可以支付
export const checkDualOrderPay = (params) => post(getBasicUrls().schoolm + 'manage/dual/order/checkDualOrderPay', params)
// 查询双重订单
export const queryDualOrderPage = params => post(getBasicUrls().schoolm + 'manage/dual/order/queryDualOrderPage', params)
// 查询双重订单
export const queryTkOrderDetail = params => get(getBasicUrls().schoolm + 'manage/tk/queryTkOrderDetail', params)
// 订单详情页面-获取订单预收运费明细
export const getPurchaseOrderItem = params => get(getBasicUrls().schoolm + 'manage/purchase/order/getPurchaseOrderItem', params)
// 总部发货页面-退运费
export const cancelOrderFreight = params => post(getBasicUrls().schoolm + 'manage/purchase/order/cancelOrderFreight', params)

// 总部发货页面-拆分发货订单信息
export const splitOrderInfo = params => post(getBasicUrls().schoolm + 'manage/goodsdeliver/splitOrderInfo', params)
// 总部发货页面-生成拆分发货单
export const createSplitDeliver = params => post(getBasicUrls().schoolm + 'manage/goodsdeliver/createSplitDeliver', params)

// 参访管理-新客参访报销列表页接口
export const visitReimbursementPage = params => post(getBasicUrls().schoolm + 'newCustomer/visitReimbursementPage', params)

// 参访管理-新客参访记录(列表页查看)
export const visitRecords = params => post(getBasicUrls().schoolm + 'newCustomer/visitRecords', params)

// 参访管理-新客参访报销申请
export const visitReimbursementApply = params => post(getBasicUrls().schoolm + 'newCustomer/visitReimbursementApply', params)

// 参访管理-新客参访记录(新增页)
export const visitRecordsByCampusId = params => get(getBasicUrls().schoolm + 'newCustomer/visitRecordsByCampusId', params)

// 参访管理-新客参访报销修改
export const updateVisitReimbursementApply = params => post(getBasicUrls().schoolm + 'newCustomer/updateVisitReimbursementApply', params)

// 新客参访报销取消
export const cancelVisitReimbursementApply = params => post(getBasicUrls().schoolm + 'newCustomer/cancelVisitReimbursementApply', params)

// 查询物流公司
export const queryTrackCompany = params => get(getBasicUrls().schoolm + 'newCustomer/queryTrackCompany', params)

// 新客参访报销详情
export const queryVisitReimbursement = params => get(getBasicUrls().schoolm + 'newCustomer/queryVisitReimbursement', params)

// 新客参访报销物流信息查询
export const queryReimbursementExpressInfo = params => post(getBasicUrls().schoolm + 'newCustomer/queryReimbursementExpressInfo', params)

// 获取经销商的所属地以及上级代理商
export const getCampusLocationAndLeader = (params) =>
  get(getBasicUrls().schoolm + "crossRegionSale/manage/getCampusLocationAndLeader", params);

// 根据报备激活获取报备地代理商以及跨区类型
export const getCrossTypeAndLocalAgent = params => post(getBasicUrls().schoolm + 'crossRegionSale/manage/getCrossTypeAndLocalAgent', params)

// 分页查询报备记录
export const pageListReport = params => post(getBasicUrls().schoolm + 'crossRegionSale/manage/pageListReport', params)

// 获取跨区域销售报备记录的详情
export const detailReport = params => post(getBasicUrls().schoolm + 'crossRegionSale/manage/detailReport', params)

// 查询跨区域活跃设备报备审核记录
export const appealPageList = params => post(getBasicUrls().schoolm + 'crossRegionSale/manage/appealPageList', params)

// 导出跨区域活跃设备报备审核记录
export const exportAppealList = params => post(getBasicUrls().schoolm + 'crossRegionSale/manage/exportAppealList', params)

// 查看跨区域活跃设备报备审核详情
export const getAppealDetail = params => get(getBasicUrls().schoolm + 'crossRegionSale/manage/getAppealDetail', params)

// 跨区域活跃设备报备审核驳回再次提交
export const reviewAppeal = params => post(getBasicUrls().schoolm + 'crossRegionSale/manage/reviewAppeal', params)

// 操作跨区域销售报备记录新增、修改、重新报备、取消
export const opReport = (params) =>
  post(getBasicUrls().schoolm + 'crossRegionSale/manage/opReport', params);

// 获取经销商名下的sn码下拉
export const getSnCodeList = (params) =>
  post(getBasicUrls().schoolm + 'crossRegionSale/manage/getSnCodeList', params);

// 查询经销商跨区域激活额度列表
export const getCrossCreditReport = (params) =>
  post(getBasicUrls().schoolm + 'crossRegionSale/manage/getCrossCreditReport', params);
// 续订卡获取充值信息
export const queryCardProduct = (params) => post(getBasicUrls().schoolm + 'manage/card/queryCardProduct', params)

//经销商剩余免审核额度查询接口
export const queryCampusIdExemptAudit = (params) => post(getBasicUrls().schoolm + 'manage/agent/queryCampusIdExemptAudit', params)

//经销商系统-学习机续费按钮校验是否满足符合服务时长

export const checkServiceDuration = (params) => post(getBasicUrls().schoolm + 'manage/card/check-service-duration', params)

// 查询账户用户状态
export const queryAccountUserStatus = (params) => post(getBasicUrls().schoolm + 'manage/agent/queryAccountUserStatus', params)

// 判断账号是否可以用手机号码登录
export const checkUserLoginType = (params) => post(getBasicUrls().schoolm + 'servicepoint/checkUserLoginType', params)
// 智适应账号绑定手机号码
export const accountBindPhoneVerify = (params) => post(getBasicUrls().schoolm + 'servicepoint/accountBindPhoneVerify', params)

// 云仓商品库存统计
export const SquirrelSettlement = (params) => post(getBasicUrls().schoolm + 'servicepoint/SquirrelSettlement', params)
// 查询所有云仓商品的总库存与可用库存 manage/warehouse/inventory/queryWarehouseProductInventoryStat POST
export const queryWarehouseProductInventoryStat = params => post(getBasicUrls().schoolm + "manage/warehouse/inventory/queryWarehouseProductInventoryStat",params);
// 云仓仓库库存统计
export const queryWarehouseInventoryStat = (params) => post(getBasicUrls().schoolm + 'manage/warehouse/inventory/queryWarehouseInventoryStat', params)

export const checkDormantAccount = (params) => post(getBasicUrls().schoolm + 'manage/agent/checkDormantAccount', params)
